import {
    InputAdornment,
    Paper,
    TableBody,
    TableCell,
    TableRow,
    Toolbar,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { DeleteForeverOutlined, Search } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/Edit';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Controls } from '../../components/controls/Controls';
import PageHeader from '../../components/PageHeader';
import Popup from '../../components/Popup';
import useTable from '../../components/useTable';
import { loadBancos, saveBanco } from '../../redux/ducks/bancos';
import BancosForm from './BancosForm';
import { setIndex } from '../../redux/ducks/sideMenuIndex';
import { filterOnAnyField } from '../../utils';
import ConfirmDialog from '../../components/ConfirmDialog';
import http from '../../http-common';

const useStyles = makeStyles((theme) => ({
    pageContent: {
        margin: theme.spacing(5),
        padding: theme.spacing(3),
    },
    searchInput: {
        width: '75%',
    },
    newButton: {},
    refreshButton: {},
}));

const headCells = [
    { id: 'nombre', label: 'Nombre' },
    { id: 'nombreCorto', label: 'Nombre Corto' },
    { id: 'pais', label: 'País' },
    { id: 'monedaPrincipal', label: 'Moneda Principal' },
    { id: 'telefono', label: 'Teléfono' },
    { id: 'actions', label: 'Acciones', disableSorting: true },
];

export default function Bancos() {
    const [openPopup, setOpenPopup] = useState(false);
    const classes = useStyles();
    const [filterFn, setFilterFn] = useState({ fn: (items) => items });
    const [recordForEdit, setRecordForEdit] = useState();

    const bancos = useSelector((state) => state.bancos.bancos);

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting,
    } = useTable(bancos, headCells, filterFn);

    const [filter, setFilter] = useState();

    const handleSearch = (e) => {
        const { target } = e;
        setFilter(target.value);
        setFilterFn({
            fn: (items) => {
                if (target.value === '') return items;
                return filterOnAnyField(items, target.value.toLowerCase());
            },
        });
    };

    const dispatch = useDispatch();

    const addOrEdit = (banco, resetForm) => {
        dispatch(saveBanco(banco));
        setOpenPopup(false);
        resetForm();
    };

    const openInPopup = (item) => {
        setRecordForEdit(item);
        setOpenPopup(true);
    };

    useEffect(() => {
        dispatch(loadBancos());
    }, [dispatch]);

    useEffect(() => {
        dispatch(setIndex(1, 'Cat'));
    }, [dispatch]);

    const [confirmDialog, setConfirmDialog] = useState({
        title: 'title',
        subtitle: 'subtitle',
        isOpen: false,
    });

    const deleteBanco = (item) => {
        setConfirmDialog({
            subtitle: '',
            title: '¿Desea borrar el banco?',
            isOpen: true,
            onConfirm: async () => {
                await http.delete(`/bancos/${item.id}`);
                dispatch(loadBancos());
            },
        });
    };

    return (
        <>
            <PageHeader
                icon={<AccountBalanceOutlinedIcon fontSize='large' />}
                subtitle=''
                title='Bancos'
            />
            <Paper className={classes.pageContent}>
                <Toolbar>
                    <Controls.Input
                        className={classes.searchInput}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position='end'>
                                    <Search />
                                </InputAdornment>
                            ),
                        }}
                        label='Buscar'
                        onChange={handleSearch}
                        value={filter}
                    />
                    <Controls.Button
                        className={classes.refreshButton}
                        onClick={() => dispatch(loadBancos())}
                        startIcon={<RefreshIcon />}
                        text='Refrescar'
                        variant='outlined'
                    />
                    <Controls.Button
                        className={classes.newButton}
                        onClick={() => {
                            setRecordForEdit(null);
                            setOpenPopup(true);
                        }}
                        startIcon={<AddIcon />}
                        text='Agregar Nuevo'
                        variant='outlined'
                    />
                </Toolbar>
                <TblContainer>
                    <TblHead />
                    <TableBody>
                        {recordsAfterPagingAndSorting().map((item) => (
                            <TableRow key={item.id}>
                                <TableCell>{item.nombre}</TableCell>
                                <TableCell>{item.nombreCorto}</TableCell>
                                <TableCell>{item.pais}</TableCell>
                                <TableCell>{item.monedaPrincipal}</TableCell>
                                <TableCell>{item.telefono}</TableCell>
                                <TableCell>
                                    <Controls.ActionButton
                                        color='primary'
                                        onClick={() => openInPopup(item)}
                                    >
                                        <EditOutlinedIcon fontSize='small' />
                                    </Controls.ActionButton>
                                    <Controls.ActionButton
                                        color='primary'
                                        onClick={() => deleteBanco(item)}
                                    >
                                        <DeleteForeverOutlined fontSize='small' />
                                    </Controls.ActionButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </TblContainer>
                <TblPagination />
            </Paper>
            <Popup
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
                title='Banco'
            >
                <BancosForm
                    addOrEdit={addOrEdit}
                    recordForEdit={recordForEdit}
                />
            </Popup>
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
        </>
    );
}
